/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_CurrentIdentitySettingByIdentityIdPut } from '../models/Model_CurrentIdentitySettingByIdentityIdPut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CurrentIdentitySettingService {
    /**
     * @param identityId
     * @returns string Success
     * @throws ApiError
     */
    public static getApiV1CurrentIdentitySettingsByIdentityId(
        identityId: ConvertDatesToStrings<string>,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/currentIdentitySettings/byIdentityId/{identityId}',
            path: {
                'identityId': identityId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static putApiV1CurrentIdentitySettingsByIdentityId(
        requestBody?: ConvertDatesToStrings<Model_CurrentIdentitySettingByIdentityIdPut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/currentIdentitySettings/byIdentityId',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
